/**
 * Übergabe in den Monat (Grundkalender-Auswahl, Kanalregel, alter Kalender-Link): Zeiträume werden
 * auf heute gekürzt – vergangene Tage nimmt der Server nicht an –, ganz vergangene fallen mit
 * Hinweis weg. Angewendet wird genau einmal; danach meldet der Monat „verbraucht“.
 */
import { useEffect, useRef } from 'react';
import { toast } from 'sonner';
import type { IsoRange } from '../calendar/rangePickerModel';

export function clampToToday(ranges: readonly IsoRange[], today: string): IsoRange[] {
  return ranges
    .filter((range) => range.to >= today)
    .map((range) => ({ from: range.from < today ? today : range.from, to: range.to }));
}

export function useMonthHandover(
  initialRanges: readonly IsoRange[] | undefined,
  today: string,
  apply: (ranges: IsoRange[]) => void,
  onApplied?: () => void,
) {
  const applied = useRef(false);
  useEffect(() => {
    if (applied.current || !initialRanges?.length) return;
    applied.current = true;
    const usable = clampToToday(initialRanges, today);
    if (usable.length < initialRanges.length) {
      toast.info(
        'Dieser Zeitraum liegt vollständig in der Vergangenheit und lässt sich nicht mehr ändern.',
      );
    }
    if (usable.length > 0) apply(usable);
    onApplied?.();
  }, [apply, initialRanges, onApplied, today]);
}
